import type { Spark } from "../sim/types";
import { glowTempK } from "./heat-glow";
import type { Renderer } from "./renderer";

const SPARK_SIZE_M = 0.4;

export function pushSparkTiles(r: Renderer, sparks: Iterable<Spark>): void {
  const uv = r.atlas.lookup.get("spark_ember");
  if (!uv) return;
  for (const sp of sparks) {
    r.pushTileRaw(
      sp.pos.x, sp.pos.y,
      SPARK_SIZE_M, SPARK_SIZE_M,
      0, 0,
      uv.u, uv.v, uv.w, uv.h,
      glowTempK(sp.tempK), 0, sp.emissivity,
      sp.vel.x, sp.vel.y, 0,
    );
  }
}
